import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { ExpandableToolMenu, ToolbarButton } from 'react-viewerbase';
import { Slider } from 'antd';
import './HeatmapButtons.css';
import qs from 'query-string';

export default class HeatmapButtons extends Component {
  static propTypes = {
    context: PropTypes.object.isRequired,
    setHeatmapContext: PropTypes.func.isRequired,
    resource: PropTypes.object,
    applicationInfo: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      buttons: [],
    };
  }

  componentDidMount() {
    this.setButton();
  }

  componentDidUpdate(prevProps) {
    if (this.props.resource !== prevProps.resource) {
      this.setButton();
    }
  }

  setButton = () => {
    const { type, from, isOtherBody } = qs.parse(window.location.search);
    let buttons = [];
    const context = { ...this.props.context };
    if (type === '9') {
      context.activeId = 'tuberculosis';
      buttons.push({
        id: 'heatmap',
        label: 'heatmap',
        icon: 'pleural-disease',
        buttons: [
          {
            id: 'tuberculosis',
            label: 'tuberculosis',
            icon: 'pleural-disease',
            type: 'setToolActive',
          },
          {
            id: 'pneumonia',
            label: 'pneumonia',
            icon: 'pleural-disease',
            type: 'setToolActive',
          },
          {
            id: 'cancer',
            label: 'cancer',
            icon: 'pleural-disease',
            type: 'setToolActive',
          },
          {
            id: 'pleural_disease',
            label: 'pleural_disease',
            icon: 'pleural-disease',
            type: 'setToolActive',
          },
        ],
      });
    } else if (type === '8') {
      const resource = this.props.resource || {};
      const scroes = resource.resultAllFinding.resultOneFinding;
      const seventh = scroes.find(
        item => item.name === 'seventh_cervical_vertebra'
      );
      const leftApex = scroes.find(item => item.name === 'left_apex');
      const rightApex = scroes.find(item => item.name === 'right_apex');

      buttons.push({
        id: 'heatmap',
        label: 'heatmap',
        icon: 'pleural-disease',
        buttons: [],
      });
      if (leftApex) {
        context.activeId = 'left_apex';
        buttons[0].buttons.push({
          id: 'left_apex',
          label: '左肺尖',
          icon: 'pleural-disease',
          type: 'setToolActive',
        });
      }

      if (rightApex) {
        buttons[0].buttons.push({
          id: 'right_apex',
          label: '右肺尖',
          icon: 'pleural-disease',
          type: 'setToolActive',
        });
      }

      buttons[0].buttons.push(
        {
          id: 'left_costophrenic_angle',
          label: 'costophrenicL',
          icon: 'pleural-disease',
          type: 'setToolActive',
        },
        {
          id: 'right_costophrenic_angle',
          label: 'costophrenicR',
          icon: 'pleural-disease',
          type: 'setToolActive',
        },
        {
          id: 'foreign_body',
          label: 'foreignObject',
          icon: 'pleural-disease',
          type: 'setToolActive',
        },
        {
          id: 'overexposure',
          label: 'overPenetration',
          icon: 'pleural-disease',
          type: 'setToolActive',
        },
        {
          id: 'underexposure',
          label: 'underPenetration',
          icon: 'pleural-disease',
          type: 'setToolActive',
        },
        {
          id: 'image_blur',
          label: 'imageBlur',
          icon: 'pleural-disease',
          type: 'setToolActive',
        }
      );
      if (seventh) {
        context.activeId = 'seventh_cervical_vertebra';
        buttons[0].buttons.push({
          id: 'seventh_cervical_vertebra',
          label: 'vertebra',
          icon: 'pleural-disease',
          type: 'setToolActive',
        });
      }
    } else if (type === '6') {
      context.activeId = 'viral_pneumonia';
      buttons.push({
        id: 'heatmap',
        label: 'heatmap',
        icon: 'pleural-disease',
        buttons: [
          {
            id: 'viral_pneumonia',
            label: 'viralPneumonia',
            icon: 'pleural-disease',
            type: 'setToolActive',
          },
        ],
      });
    } else if (type === '11') {
      context.activeId = 'tuberculosis';
      const child = [
        {
          id: 'tuberculosis',
          label: 'tuberculosis1',
          icon: 'pleural-disease',
          type: 'setToolActive',
        },
      ];

      const institutionIds = [
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
      ];
      const currentInstitutionId = this.props.applicationInfo.institutionId;
      if (institutionIds.indexOf(currentInstitutionId) >= 0) {
        child.push({
          id: 'old_tuberculosis',
          label: 'old_tuberculosis',
          icon: 'pleural-disease',
          type: 'setToolActive',
        });
      }
      buttons.push({
        id: 'heatmap',
        label: 'heatmap',
        icon: 'pleural-disease',
        buttons: child,
      });
    } else if (from === 'report') {
      context.activeId = 'ai-report';
      buttons.push({
        id: 'heatmap',
        label: 'heatmap',
        icon: 'pleural-disease',
        buttons: [
          {
            id: 'ai-report',
            label: 'ai-report',
            icon: 'pleural-disease',
            type: 'setToolActive',
          },
        ],
      });
    } else if (from === 'screening') {
      context.activeId = 'screening';
      buttons.push({
        id: 'heatmap',
        label: 'heatmap',
        icon: 'pleural-disease',
        buttons: [
          {
            id: 'screening',
            label: '肺结核',
            icon: 'pleural-disease',
            type: 'setToolActive',
          },
        ],
      });
    }
    buttons.push({
      id: 'opacity',
      label: 'opacity',
      icon: 'opactity',
      type: 'command',
      marks: { 0: '0%', 25: '25%', 50: '50%', 75: '75%', 100: '100%' },
    });
    if (isOtherBody === 'true') buttons = [];

    this.setState({ buttons });
    this.props.setHeatmapContext(context);
  };

  handleButtonClick = (button, value) => {
    let context = { ...this.props.context };
    if (button.type === 'setToolActive') {
      context = { ...context, activeId: button.id, opacity: 100 };
    } else if (button.type === 'command') {
      context = { ...context, opacity: value };
    }

    this.props.setHeatmapContext(context);
  };

  render() {
    const { from } = qs.parse(window.location.search);
    const { buttons } = this.state;
    return buttons.map((button, index) => {
      if (button.buttons && button.buttons.length) {
        const childButtons = button.buttons.map(childButton => {
          childButton.onClick = this.handleButtonClick.bind(this, childButton);
          return childButton;
        });
        return from === 'report' ? null : (
          <ExpandableToolMenu
            key={button.id}
            label={button.label}
            icon={button.icon}
            buttons={childButtons}
            activeCommand={this.props.context.activeId}
          />
        );
      }
      return button.type === 'button' ? (
        <ToolbarButton
          key={button.id}
          label={button.label}
          icon={button.icon}
          onClick={() => this.handleButtonClick(button)}
          isActive={button.id === this.props.context.activeId}
        />
      ) : (
        <span key={index}>
          {from === 'report' ? null : (
            <Slider
              className="opacity-ant-slider"
              key={button.id}
              marks={button.marks}
              value={this.props.context.opacity}
              onChange={() => this.handleButtonClick(button)}
            />
          )}
        </span>
      );
    });
  }
}
